import React from 'react';
// context to be used when the user wants full screen swipe (see `gesture-handler` folder in repo)
export const GHContext = /*#__PURE__*/React.createContext(props => /*#__PURE__*/React.createElement(React.Fragment, null, props.children));
//# sourceMappingURL=GHContext.js.map